export default __webpack_public_path__ + "static/media/about-us-1.289a414b.jpg";